import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=2b240836&scoped=true"
import script from "./Regist.vue?vue&type=script&lang=js"
export * from "./Regist.vue?vue&type=script&lang=js"
import style0 from "./Regist.vue?vue&type=style&index=0&id=2b240836&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b240836",
  null
  
)

export default component.exports